module.exports = __webpack_public_path__ + "img/service-tab-img2.177b2e1a.png";